import './App.css';
import TemplateProvider from './context/TemplateProvider';
import { AuthProvider } from './context/AuthProvider';
import { ModalProvider } from './context/ModalContext';
import RouteHandler from './utility/RouteHandler';
import Modal from './components/Modal';

function App() {
  return (
    <TemplateProvider>
    <AuthProvider>
        <ModalProvider>
          <RouteHandler />
          <Modal />
        </ModalProvider>
    </AuthProvider>
</TemplateProvider>
  );
}

export default App;
